import React, { useState, useEffect } from 'react';
import { reelDiscovery } from '../api';

export default function HashtagChallenge({ onJoin }) {
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    reelDiscovery.getChallenges(true)
      .then(data => setChallenges(data.challenges || []))
      .catch(() => setError('Failed to load challenges'))
      .finally(() => setLoading(false));
  }, []);

  const handleJoin = async (challengeId) => {
    if (onJoin) onJoin(challengeId);
  };

  if (loading) {
    return <div style={{ padding: 16, color: 'var(--reels-muted, #666)' }}>Loading challenges...</div>;
  }

  if (!challenges.length) {
    return (
      <div style={{ padding: 16 }}>
        <h4 style={{ color: '#f5a623', fontSize: 14, fontWeight: 700, marginBottom: 8 }}>
          🏆 Hashtag Challenges
        </h4>
        <p style={{ color: 'var(--reels-muted, #666)', fontSize: 13 }}>No active challenges right now. Check back soon!</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '12px 0' }}>
      <h4 style={{ color: '#f5a623', marginBottom: 12, fontSize: 14, fontWeight: 700 }}>
        🏆 Hashtag Challenges
      </h4>

      {error && <div style={{ color: '#ef4444', fontSize: 13, marginBottom: 8 }}>{error}</div>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {challenges.map((challenge) => {
          const now = new Date();
          const startDate = new Date(challenge.startsAt);
          const endDate = challenge.endsAt ? new Date(challenge.endsAt) : null;
          const isActive = challenge.isActive && startDate <= now && (!endDate || endDate > now);

          return (
            <div
              key={challenge.id}
              style={{
                background: 'var(--reels-card-bg, rgba(255,255,255,0.04))',
                border: isActive ? '1px solid rgba(78,203,141,0.3)' : '1px solid var(--reels-border, #2a3a48)',
                borderRadius: 12,
                padding: 16,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--reels-fg, #fff)', marginBottom: 4 }}>
                    #{challenge.hashtag}
                  </div>
                  <div style={{ fontSize: 13, color: 'var(--reels-muted, #999)', marginBottom: 8 }}>
                    {challenge.description || 'No description'}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--reels-muted, #666)' }}>
                    {challenge._count?.entries || challenge.totalEntries || 0} entries
                    {challenge.prize && <> · 🏆 Prize: {challenge.prize}</>}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--reels-muted, #666)', marginTop: 4 }}>
                    {startDate.toLocaleDateString()} {endDate ? `- ${endDate.toLocaleDateString()}` : ''}
                  </div>
                </div>
                <button
                  onClick={() => handleJoin(challenge.id)}
                  disabled={!isActive}
                  style={{
                    padding: '8px 16px',
                    borderRadius: 8,
                    border: 'none',
                    background: isActive ? 'linear-gradient(135deg, #4ecb8d, #3ab87a)' : 'var(--reels-border, #2a3a48)',
                    color: isActive ? '#fff' : '#666',
                    cursor: isActive ? 'pointer' : 'not-allowed',
                    fontSize: 13,
                    fontWeight: 700,
                  }}
                >
                  {isActive ? 'Join' : 'Ended'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
